import { CartLinesUpdateEvent } from '@shopify/events';

const cfg = window.aptsWish || {};
const KEY = 'apts_wishlist';
const HEART = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M12 20.3s-7.4-4.5-9.2-9.1C1.5 7.8 3.7 4.5 7.1 4.5c2 0 3.6 1.1 4.9 2.9 1.3-1.8 2.9-2.9 4.9-2.9 3.4 0 5.6 3.3 4.3 6.7-1.8 4.6-9.2 9.1-9.2 9.1z"/></svg>';

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch (e) {
    return [];
  }
};
const write = (list) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch (e) {}
  sync();
};
const toggle = (handle) => {
  const list = read();
  const i = list.indexOf(handle);
  if (i > -1) list.splice(i, 1);
  else list.unshift(handle);
  write(list);
};
const handleFrom = (href) => {
  const m = (href || '').match(/\/products\/([^/?#]+)/);
  return m ? decodeURIComponent(m[1]) : null;
};
const money = (cents) => `R${(cents / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

function sync() {
  const list = read();
  document.querySelectorAll('[data-apts-wish]').forEach((b) => {
    const on = list.includes(b.dataset.aptsWish);
    b.classList.toggle('is-on', on);
    b.setAttribute('aria-pressed', on);
    const label = b.querySelector('[data-wish-label]');
    if (label) label.textContent = on ? cfg.added : cfg.add;
    else b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
  });
  document.querySelectorAll('[data-apts-wish-count]').forEach((c) => {
    c.textContent = list.length;
    c.hidden = !list.length;
  });
}

function decorate() {
  document.querySelectorAll('product-card:not([data-wish-done]), .apts-pairs__card:not([data-wish-done])').forEach((card) => {
    card.dataset.wishDone = '1';
    const handle = handleFrom(card.querySelector('a[href*="/products/"]')?.getAttribute('href'));
    if (!handle) return;
    const host = card.querySelector('.card-gallery, .apts-pairs__img') || card;
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'apts-wish apts-wish--card';
    b.dataset.aptsWish = handle;
    b.innerHTML = HEART;
    host.classList.add('apts-wish-host');
    host.appendChild(b);
  });

  if (!document.querySelector('.apts-wish-link')) {
    const cart = document.querySelector('cart-icon')?.closest('.header-actions__action');
    if (cart) {
      const a = document.createElement('a');
      a.href = cfg.page;
      a.className = 'header-actions__action apts-wish-link';
      a.setAttribute('aria-label', 'Wishlist');
      a.innerHTML = `${HEART}<span class="apts-wish-link__count" data-apts-wish-count hidden></span>`;
      cart.before(a);
    }
  }

  const productHandle = handleFrom(location.pathname);
  const form = document.querySelector('product-form-component');
  if (productHandle && form && !document.querySelector('.apts-wish--pdp')) {
    const anchor = form.closest('.buy-buttons-block') || form;
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'apts-wish apts-wish--pdp';
    b.dataset.aptsWish = productHandle;
    b.innerHTML = `${HEART}<span data-wish-label>${esc(cfg.add)}</span>`;
    anchor.after(b);
  }
  sync();
}

document.addEventListener(
  'click',
  (e) => {
    const b = e.target.closest?.('[data-apts-wish]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(b.dataset.aptsWish);
    const page = document.querySelector('[data-apts-wish-page]');
    if (page && !read().includes(b.dataset.aptsWish)) b.closest('.apts-wl__card')?.remove();
    if (page && !read().length) renderPage();
  },
  true
);

window.addEventListener('storage', (e) => {
  if (e.key === KEY) sync();
});

async function addToCart(btn) {
  btn.disabled = true;
  btn.textContent = 'Adding…';
  const sections = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }], sections: sections.join(','), sections_url: location.pathname })
  }).then((r) => r.json());
  if (res.status) {
    btn.textContent = 'Sold out';
    return;
  }
  const cart = await fetch('/cart.js').then((r) => r.json());
  const deferred = CartLinesUpdateEvent.createPromise();
  document.body.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [], promise: deferred.promise }));
  deferred.resolve({
    cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
    detail: { items: cart.items, itemCount: cart.item_count, sections: res.sections, source: 'apts-wishlist', didError: false }
  });
  btn.textContent = 'Added';
  setTimeout(() => {
    btn.textContent = 'Add to cart';
    btn.disabled = false;
  }, 2000);
}

async function renderPage() {
  const page = document.querySelector('[data-apts-wish-page]');
  if (!page) return;
  const grid = page.querySelector('[data-wl-grid]');
  const empty = page.querySelector('[data-wl-empty]');
  const list = read();
  if (!list.length) {
    grid.innerHTML = '';
    empty.hidden = false;
    return;
  }
  empty.hidden = true;
  const products = await Promise.all(list.map((h) => fetch(`/products/${encodeURIComponent(h)}.js`).then((r) => (r.ok ? r.json() : null)).catch(() => null)));
  const gone = list.filter((h, i) => !products[i]);
  if (gone.length) write(list.filter((h) => !gone.includes(h)));
  grid.innerHTML = products
    .filter(Boolean)
    .map((p) => {
      const v = p.variants.find((x) => x.available) || p.variants[0];
      const img = p.featured_image ? `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=500` : '';
      const sale = v.compare_at_price > v.price;
      const action = !p.available
        ? '<span class="apts-wl__out">Sold out</span>'
        : p.variants.length === 1
          ? `<button type="button" class="apts-wl__add" data-wl-add data-variant="${v.id}">Add to cart</button>`
          : `<a class="apts-wl__add" href="/products/${p.handle}">Choose options</a>`;
      return `<li class="apts-wl__card">
        <a class="apts-wl__img" href="/products/${p.handle}">${img ? `<img src="${img}" alt="${esc(p.title)}" loading="lazy">` : ''}</a>
        <button type="button" class="apts-wish apts-wish--card is-on" data-apts-wish="${esc(p.handle)}" aria-label="Remove from wishlist">${HEART}</button>
        <a class="apts-wl__title" href="/products/${p.handle}">${esc(p.title)}</a>
        <span class="apts-wl__price${sale ? ' is-sale' : ''}">${p.price_varies ? 'From ' : ''}<span>${money(v.price)}</span>${sale ? ` <s>${money(v.compare_at_price)}</s>` : ''}</span>
        ${action}
      </li>`;
    })
    .join('');
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest?.('[data-wl-add]');
  if (btn && !btn.disabled) addToCart(btn);
});

let timer;
new MutationObserver(() => {
  clearTimeout(timer);
  timer = setTimeout(decorate, 150);
}).observe(document.body, { childList: true, subtree: true });

decorate();
renderPage();
